<template>
  <div>
    <fieldset>
      <div class="row px-2">
        <div class="col-md-12">
          <label class="form-label" for="frontpage"
            >Separate client front page?:</label
          >
        </div>

        <div class="col-md-3">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              :value="false"
              v-model="form.frontpage"
            />
            <label class="form-check-label" for="frontpage">No</label>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              :value="true"
              v-model="form.frontpage"
            />
            <label class="form-check-label" for="frontpage">Yes</label>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-7">
            <label
              class="form-label d-inline"
              style="white-space: nowrap;"
              for="directory"
              >Directory:</label
            >
            <p class="d-inline" style="white-space: nowrap;">
              (just directory name, lower case, not full path)
              www.incentiveweb.com/&lt;directoryName&gt;
            </p>
            <input type="text" class="form-control" v-model="form.directory" />
          </div>

          <div class="col-md-7 mt-3 d-flex align-items-center">
            <label class="form-label" for="directoryDriver"
              >Use this client's settings for Login Page Image and Welcome
              message for all clients using this directory?:</label
            >
           
              <b-form-checkbox
                class="ml-2"
                switch
                :false-value="false"
                :true-value="true"
                role="switch"
                v-model="form.directoryDriver"
              />
            
          </div>

          <div class="col-md-7 mt-3">
            <label for="copy" class="form-label"
              >Welcome description message:</label
            >
            <textarea
              class="form-control"
              name="copy"
              rows="5"
              cols="23"
              disabled
              v-model="form.copy"
            ></textarea>
          </div>

          <div class="col-md-7 mt-3">
            <label for="username_txt" class="form-label"
              >"User" text title:</label
            >
            (Logon field title)
            <input
              class="form-control"
              name="username_txt"
              type="text"
              aria-label="Disabled input example"
              disabled
              v-model="form.username_txt"
            />
          </div>

          <div class="col-md-7 mt-3">
            <label for="password_txt" class="form-label"
              >"Password" text title:</label
            >
            (Logon field title)
            <input
              class="form-control"
              name="password_txt"
              type="text"
              aria-label="Disabled input example"
              disabled
              v-model="form.password_txt"
            />
          </div>

          <div class="col-md-7 mt-3 d-flex align-items-center">
            <label for="AllowSendPassword" class="form-label"
              >Allow send password:</label
            >
           
              <b-form-checkbox
                class="ml-2 mb-2"
                switch
                :false-value="false"
                :true-value="true"
                role="switch"
                name="AllowSendPassword"
                v-model="form.AllowSendPassword"
              />
            
          </div>

          <div class="col-md-7 mt-3">
            <div class="mb-3">
              <label for="loginImage" class="form-label"
                >Login page image:</label
              >
              <br />
              <b-form-file v-model="form.loginImage" plain />
            </div>
          </div>

          <div class="col-md-12 mt-3">
            <label for="use_password" class="form-label">Require logon:</label>
          </div>

          <div class="col-md-4">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="use_password"
                :value="true"
                v-model="form.use_password"
              />
              <label class="form-check-label" for="use_password">Yes</label>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="use_password"
                :value="false"
                v-model="form.use_password"
              />
              <label class="form-check-label" for="use_password">No</label>
            </div>
          </div>

          <div class="col-md-6 mt-3">
            <label for="bgcolor" class="form-label">Background color:</label>
            <b-select
              class="form-select"
              name="bgcolor"
              aria-label="Default select example"
              v-model="form.bgcolor"
            >
              <option value="">Use Hex</option>
              <option value="White">White</option>
              <option value="Aqua" style="color: Aqua">Aqua</option>
              <option value="Black">Black</option>
              <option value="Blue" style="color: Blue">Blue</option>
              <option value="Fuchsia" style="color: Fuchsia">Fuchsia</option>
              <option value="Gray" style="color: Gray">Gray</option>
              <option value="Green" style="color: Green">Green</option>
              <option value="Lime" style="color: Lime">Lime</option>
              <option value="Maroon" style="color: Maroon">Maroon</option>
              <option value="Navy" style="color: Navy">Navy</option>
              <option value="Olive" style="color: Olive">Olive</option>
              <option value="Purple" style="color: Purple">Purple</option>
              <option value="Red" style="color: Red">Red</option>
              <option value="Teal" style="color: Teal">Teal</option>
              <option value="Yellow" style="color: Yellow">Yellow</option>
            </b-select>
          </div>

          <div class="col-md-6 mt-3">
            <label for="bgcolor" class="form-label">Optional hex:</label>
            <input
              class="form-control"
              type="text"
              name="bgcolor"
              v-model="form.bgcolor"
            />
          </div>

          <div class="col-md-7 mt-3">
            <label for="txtcolor" class="form-label">Text color: </label>
            <b-select class="form-select" name="txtcolor" v-model="form.txtcolor">
              <option value="White">White</option>
              <option value="Aqua" style="color: Aqua">Aqua</option>
              <option value="Black">Black</option>
              <option value="Blue" style="color: Blue">Blue</option>
              <option value="Fuchsia" style="color: Fuchsia">Fuchsia</option>
              <option value="Gray" style="color: Gray">Gray</option>
              <option value="Green" style="color: Green">Green</option>
              <option value="Lime" style="color: Lime">Lime</option>
              <option value="Maroon" style="color: Maroon">Maroon</option>
              <option value="Navy" style="color: Navy">Navy</option>
              <option value="Olive" style="color: Olive">Olive</option>
              <option value="Purple" style="color: Purple">Purple</option>
              <option value="Red" style="color: Red">Red</option>
              <option value="Teal" style="color: Teal">Teal</option>
              <option value="Yellow" style="color: Yellow">Yellow</option>
            </b-select>
          </div>

          <div class="col-md-7 mt-3">
            <label for="program_name" class="form-label">Program name:</label>
            <input
              class="form-control"
              type="text"
              name="program_name"
              v-model="form.program_name"
            />
          </div>

          <div class="col-md-7 mt-3">
            <label for="program_desc" class="form-label"
              >Program description:</label
            >
            <textarea
              class="form-control"
              name="program_desc"
              rows="5"
              cols="23"
              v-model="form.program_desc"
            ></textarea>
          </div>

          <div class="col-md-7 mt-3">
            <label for="hpMessage" class="form-label">Homepage message:</label>
            <textarea
              class="form-control"
              name="hpMessage"
              rows="5"
              cols="23"
              v-model="form.hpMessage"
            ></textarea>
          </div>

          <div class="col-md-7 mt-3">
            <label for="hprightvideo" class="form-label"
              >Homepage Right Side Description:</label
            >
            <textarea
              class="form-control"
              name="hprightvideo"
              v-model="form.hprightvideo"
              rows="5"
              cols="23"
            ></textarea>
          </div>

          <div class="col-md-7 mt-3">
            <label for="spwhatshottitle" class="form-label"
              >Shop Page Whats Hot Title:</label
            >
            <textarea
              class="form-control"
              name="spwhatshottitle"
              v-model="form.spwhatshottitle"
              rows="5"
              cols="23"
            ></textarea>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-4">
            <label for="headercolor" class="form-label">Header color:</label>
            <b-select
              class="form-select"
              name="headercolor"
              v-model="form.headercolor"
            >
              <option value="Orange" style="color: Orange">Orange</option>
              <option value="Brown" style="color: Brown">Brown</option>
              <option value="Yellow" style="color: Yellow">Yellow</option>
              <option value="grey" style="color: grey">grey</option>
              <option value="blue" style="color: blue">blue</option>
              <option value="red" style="color: red">red</option>
            </b-select>
          </div>

          <div class="col-md-4">
            <label for="headerfontcolor" class="form-label"
              >Header font color:</label
            >
            <b-select
              class="form-select"
              name="headerfontcolor"
              v-model="form.headerfontcolor"
            >
              <option value="White" style="color: White">White</option>
              <option value="Orange" style="color: Orange">Orange</option>
              <option value="Brown" style="color: Brown">Brown</option>
              <option value="Yellow" style="color: Yellow">Yellow</option>
              <option value="grey" style="color: grey">grey</option>
              <option value="blue" style="color: blue">blue</option>
              <option value="red" style="color: red">red</option>
            </b-select>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-4">
            <label for="buttoncolor" class="form-label">Button color:</label>
            <b-select
              class="form-select"
              name="buttoncolor"
              v-model="form.buttoncolor"
            >
              <option value="Orange" style="color: Orange">Orange</option>
              <option value="Brown" style="color: Brown">Brown</option>
              <option value="Yellow" style="color: Yellow">Yellow</option>
              <option value="grey" style="color: grey">grey</option>
              <option value="blue" style="color: blue">blue</option>
              <option value="red" style="color: red">red</option>
            </b-select>
          </div>

          <div class="col-md-4">
            <label for="buttonfontcolor" class="form-label"
              >Button font color:</label
            >
            <b-select
              class="form-select"
              name="buttonfontcolor"
              v-model="form.buttonfontcolor"
            >
              <option value="White" style="color: White">White</option>
              <option value="Orange" style="color: Orange">Orange</option>
              <option value="Brown" style="color: Brown">Brown</option>
              <option value="Yellow" style="color: Yellow">Yellow</option>
              <option value="grey" style="color: grey">grey</option>
              <option value="blue" style="color: blue">blue</option>
              <option value="red" style="color: red">red</option>
            </b-select>
          </div>

          <div class="col-md-7 mt-3">
            <label for="blogheading" class="form-label"
              >Homepage blog heading:</label
            >
            <input
              class="form-control"
              type="text"
              name="blogheading"
              v-model="form.blogheading"
            />
          </div>

          <div class="col-md-7 mt-3">
            <label for="hpBlog1URL" class="form-label"
              >Homepage blog 1 URL:</label
            >
            <textarea
              class="form-control"
              name="hpBlog1URL"
              v-model="form.hpBlog1URL"
              rows="5"
              cols="23"
            ></textarea>
          </div>

          <div class="col-md-7 mt-3">
            <label for="hpBlog2URL" class="form-label"
              >Homepage blog 2 URL:</label
            >
            <textarea
              class="form-control"
              name="hpBlog2URL"
              v-model="form.hpBlog2URL"
              rows="5"
              cols="23"
            ></textarea>
          </div>

          <div class="col-md-7 mt-3">
            <label for="hpBlog3URL" class="form-label"
              >Homepage blog 3 URL:</label
            >
            <textarea
              class="form-control"
              name="hpBlog3URL"
              v-model="form.hpBlog3URL"
              rows="5"
              cols="23"
            ></textarea>
          </div>

          <div class="col-md-7 mt-3">
            <label for="videoheading" class="form-label">Video heading:</label>
            <input
              class="form-control"
              type="text"
              name="videoheading"
              v-model="form.videoheading"
            />
          </div>

          <div class="col-md-7 mt-3">
            <label for="youTubeVideoURL" class="form-label"
              >YouTube video URL:</label
            >
            <textarea
              class="form-control"
              name="youTubeVideoURL"
              rows="5"
              cols="23"
            ></textarea>
          </div>

          <div class="col-md-7 mt-3">
            <input
              type="submit"
              class="btn btn-primary"
              value="Add another video"
            />
          </div>

          <div class="col-md-7 mt-3">
            <div>
              <label for="logo" class="form-label">Logo image:</label>
              <b-form-file name="logo" v-model="form.logo" plain />
            </div>
          </div>

          <div class="col-md-7 mt-3">
            <div>
              <label for="hpImage" class="form-label">Homepage image:</label>
               <b-form-file name="hpImage" v-model="form.hpImage" plain />
            </div>
          </div>

          <div class="col-md-7 mt-3">
            <div>
              <label for="background" class="form-label"
                >Background image:</label
              >
              (Optional)
          <b-form-file name="background" v-model="form.background" plain />
            </div>
          </div>

          <div class="col-md-7 mt-3">
            <div>
              <label for="image_left" class="form-label"
                >Left side image:</label
              >
          <b-form-file name="image_left" v-model="form.image_left" plain />
            </div>
          </div>

          <div class="col-md-7 mt-3">
            <div>
              <label for="image_right" class="form-label"
                >Right side image:</label
              >
          <b-form-file name="image_right" v-model="form.image_right" plain />   
            </div>
          </div>

          <div class="col-md-7 mt-3">
            <div>
              <label for="image_bottom" class="form-label">Bottom image:</label>
              <b-form-file name="image_bottom" v-model="form.image_bottom" plain />
            </div>
          </div>
        </div>
      </div>
    </fieldset>

    <fieldset>
      <legend>User registration</legend>
      <div class="row">
        <div class="col-md-12">
          <label class="form-label" for="registrationallow"
            >Can users register by themselves?
          </label>
        </div>

        <div class="col-md-3">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="frontpage"
              :value="false"
              v-model="form.registrationallow"
            />
            <label class="form-check-label" for="flexRadioDefault1">No</label>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="frontpage"
              :value="true"
              v-model="form.registrationallow"
            />
            <label class="form-check-label" for="flexRadioDefault1">Yes</label>
          </div>
        </div>

        <div class="col-md-12 mt-3">
          <label class="form-label" for="registrationnotification"
            >List the email addresses of those who need to be notified of a new
            user registration. Seperate each email address with a semi-colon
            ";":</label
          >
          <textarea
            cols="60"
            rows="5"
            name="comments"
            class="form-control"
            v-model="form.registrationnotification"
          ></textarea>
        </div>

        <div class="col-md-12 mt-3">
          <label class="form-label" for="registrationwelcome"
            >Enter the text that will appear on the registration page:</label
          >
          <textarea
            cols="60"
            rows="5"
            name="comments"
            class="form-control"
            v-model="form.registrationwelcome"
          ></textarea>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
export default {
  name: "SeparateClient",
  data() {
    return {};
  },

  computed: {
    form() {
      return this.$store.state.manageClients.form;
    },
  },
  methods: {
    // onChange(event) {
    // var files = e.target.files || e.dataTransfer.files;
    // if (!files.length) return;
    // var newFile = this.createImage(files[0]);
    // this.form.loginImage = newFile;
    // console.log(this.form.loginImage)
    // let url = "";
    // url = URL.createObjectURL(this.form.loginImage)
    // this.form.loginImage = url;
    // console.log(this.form.loginImage)
    // this.form.loginImage = event.target.files[0];
    // const fd = new FormData();
    // fd.append("image", this.form.loginImage, this.form.loginImage.name);
    // this.form.loginImage = fd;
    // console.log(this.form.loginImage);
    // },
    // onUpload() {
    //   const formData = new FormData();
    //   formData.append("loginImage", this.loginImage, this.loginImage.name);
    // },
  },
};
</script>
<style></style>
